import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { from } from 'rxjs';
import { MapApi } from '../../../api/map-api';
import { MapService } from '../../../services/map.service';
import { BaseComponent } from '../../base.component';
/* tslint:disable:template-cyclomatic-complexity */
var MapCatalogItemComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MapCatalogItemComponent, _super);
    function MapCatalogItemComponent(authService, _vcr, mapApi, mapService, ref) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.mapApi = mapApi;
        _this.mapService = mapService;
        _this.ref = ref;
        _this.owner = false;
        _this.closeWindowEvent = new EventEmitter();
        _this.changeFolderEvent = new EventEmitter();
        _this.deleteMapEvent = new EventEmitter();
        _this.mapOpened = new EventEmitter();
        _this.expanded = false;
        _this.showMapDetailIcon = 'icon-ui-arrow-down-circled';
        _this.canViewUsers = false;
        _this._userId = null;
        _this.openMergeMap = new EventEmitter();
        authService.permissions.subscribe(function (permissions) {
            _this.canViewUsers = permissions && permissions.includes('View Users');
        });
        return _this;
    }
    Object.defineProperty(MapCatalogItemComponent.prototype, "includeGoogleAnalytics", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCatalogItemComponent.prototype, "userId", {
        get: function () { return this._userId; },
        set: function (value) {
            this._userId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCatalogItemComponent.prototype, "includeEsriCss", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCatalogItemComponent.prototype, "includeOverrideCss", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCatalogItemComponent.prototype, "publicUrl", {
        get: function () {
            var retVal = null;
            if (this.map && this.map.isPublic) {
                var newUrl = new URL(window.location.href);
                newUrl.search = "mapId=" + this.map.id;
                retVal = newUrl.href;
            }
            return retVal;
        },
        enumerable: true,
        configurable: true
    });
    MapCatalogItemComponent.prototype.toggleMapItem = function () {
        this.expanded = !this.expanded;
        this.showMapDetailIcon = this.expanded ? 'icon-ui-arrow-up-circled' : 'icon-ui-arrow-down-circled';
    };
    MapCatalogItemComponent.prototype.toggleMultiSelectCheckbox = function () {
        this.map.selected = !(this.map.selected === true);
    };
    MapCatalogItemComponent.prototype.mergeMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.openMergeMap.emit(this.map);
                        return [4 /*yield*/, this.closeWindow()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogItemComponent.prototype.getMapDetails = function (map) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mapIds, mapProps, maps;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mapIds = [map.id];
                        mapProps = this.mapApi.mapProperties + ', userMaps { userId, accessLevel, sharedWith{ userId }}';
                        if (!mapIds.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.mapService.getMaps(mapIds, mapProps)];
                    case 1:
                        maps = _a.sent();
                        this.checkedMap = from(maps.map(function (Map) {
                            var sharedWith = _this.cleanMapGetSharedWith(Map);
                            return { Map: Map, sharedWith: sharedWith };
                        }));
                        this.checkedMap.subscribe(function (res) {
                            _this.showMap = res;
                            _this.ref.detectChanges();
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogItemComponent.prototype.cleanMapGetSharedWith = function (map) {
        var _this = this;
        //establish a workable, not null user maps arr for the map
        var userMapsArr = map.userMaps && Array.isArray(map.userMaps) && map.userMaps.length ? map.userMaps : [];
        //determine user who owns this map
        var ownerRec = userMapsArr.find(function (item) { return item.accessLevel === 'OWNER'; });
        if (ownerRec && map.users && Array.isArray(map.users)) {
            //try to find the owner in Users to get their info
            var ownerUser = map.users.find(function (item) { return item.id === ownerRec.userId; });
            if (ownerUser) {
                map.owner = ownerUser;
            }
        }
        //find the current user in the map record
        var currentUserMapRec = userMapsArr.find(function (item) { return item.userId === _this.userId; });
        var sharedWith = [];
        //if the current user is properly listed in the userMaps array, it will have an array of sharedWith to indicate who this user has shared the map with
        //this array should be the one used to determine if the unshare button should show or not.
        if (currentUserMapRec && currentUserMapRec.sharedWith) {
            sharedWith = currentUserMapRec.sharedWith;
        }
        return sharedWith;
    };
    MapCatalogItemComponent.prototype.openMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.closeWindow();
                        return [4 /*yield*/, this.mapService.openMap(this.map)];
                    case 1:
                        _a.sent();
                        this.mapOpened.emit(this.map);
                        return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogItemComponent.prototype.shareMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var win, shareMap;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        win = window.document.getElementById('shareMapWindow');
                        if (win) {
                            win.open();
                            shareMap = win.firstElementChild;
                            shareMap.map = this.map;
                        }
                        return [4 /*yield*/, this.closeWindow()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogItemComponent.prototype.unshareMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var win, unshareMap;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        win = window.document.getElementById('unshareMapWindow');
                        if (win) {
                            win.open();
                            unshareMap = win.firstElementChild;
                            unshareMap.map = this.map;
                        }
                        return [4 /*yield*/, this.closeWindow()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogItemComponent.prototype.deleteMap = function (map) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.deleteMapEvent.emit(map);
                return [2 /*return*/];
            });
        });
    };
    MapCatalogItemComponent.prototype.changeFolder = function (map) {
        this.changeFolderEvent.emit(map.id);
    };
    MapCatalogItemComponent.prototype.closeWindow = function () {
        this.multiSelectEnabled = false;
        if (this.map.length !== undefined) {
            this.map.forEach(function (x) { return x.selected = false; });
        }
        this.closeWindowEvent.emit(true);
    };
    return MapCatalogItemComponent;
}(BaseComponent));
export { MapCatalogItemComponent };
